/**
 * Что привязка ниши меняет в расчёте (WS 15587410, п.2): «заполняется автоматически
 * конверсия (серч конверсия × 2) и ретурн рейт ниши».
 *
 * Поля калькулятора — в процентах, у ниши — доли (0.047). Показателя у ниши нет —
 * поле не трогаем: подставить ноль значило бы молча обнулить введённое человеком.
 */

import type { Niche } from '../../shared/api/client';

/** Множитель из задачи: конверсия листинга ≈ конверсия поиска ниши × 2. */
export const NICHE_CONVERSION_MULTIPLIER = 2;

export interface NicheFill {
  conversionRate?: number;
  returnRate?: number;
}

const round2 = (v: number) => Math.round(v * 100) / 100;

export function nicheFill(niche: Niche): NicheFill {
  const fill: NicheFill = {};
  if (niche.search_conversion_rate != null) {
    fill.conversionRate = round2(niche.search_conversion_rate * NICHE_CONVERSION_MULTIPLIER * 100);
  }
  if (niche.return_rate != null) {
    fill.returnRate = round2(niche.return_rate * 100);
  }
  return fill;
}

/** Снимок для сохранения в расчёте — с моментом привязки. */
export function bindSnapshot(niche: Niche, now: Date = new Date()): Niche {
  return { ...niche, bound_at: now.toISOString() };
}

export function formatShare(v: number | null | undefined): string {
  return v == null ? '—' : `${(v * 100).toFixed(1)}%`;
}

export function formatCount(v: number | null | undefined, locale: string): string {
  if (v == null) return '—';
  if (v >= 1_000_000) return `${(v / 1_000_000).toLocaleString(locale, { maximumFractionDigits: 2 })} M`;
  if (v >= 1_000) return `${Math.round(v / 1_000).toLocaleString(locale)} K`;
  return Math.round(v).toLocaleString(locale);
}

export function formatPrice(v: number | null | undefined): string {
  return v == null ? '—' : `$${v.toFixed(2)}`;
}

// POE пускает только с платформенным токеном (QA 08.10, WS 15587410, п.3): 401 — у
// пользователя его нет (вход по паролю), 403 — POE отказал этой учётке. Оба — не авария,
// и «повторите позже» про них было бы неправдой.
export function nicheErrorKey(status: number | undefined): string {
  if (status === 401) return 'idea_calc.niche.error_platform_only';
  if (status === 403) return 'idea_calc.niche.error_rejected';
  if (status === 503) return 'idea_calc.niche.error_not_configured';
  return 'idea_calc.niche.error_unavailable';
}
